export default {
    colorScheme: {
        light: {
            text: {
                color: {
                    brand: '{primary.color}',
                    link: '{primary.color}',
                    primary: '{primary.color}',
                    error: '{red.600}',
                    success: '{green.500}',
                    secondary: '{surface.800}',
                    info: '{sky.400}',
                    warn: '{orange.400}',
                    help: '{purple.400}',
                    contrast: '{surface.0}'
                }
            },
            panel: {
                background: '{surface.100}'
            }
        },
        dark: {
            text: {
                color: {
                    brand: '{text.color}',
                    link: '{primary.color}',
                    primary: '{primary.color}',
                    error: '{red.400}',
                    success: '{green.400}',
                    secondary: '{surface.300}'
                }
            },
            /* Panels share the card surface (900) so form fields at 800 read one step lighter */
            panel: {
                background: '{surface.900}'
            }
        }
    }
};
